export const ActiveCampaignMock = [
  {
    campaignsName: "Smarpay wallet promo",
    validFrom: "01.05.2023",
    validTo: "01.06.2023",
    scope: "New customers",
    issuedVauchers: 325,
    state: "Running",
    MSISDNS: "041111222333",
  },
  {
    campaignsName: "Coca Cola Zero",
    validFrom: "01.06.2023",
    validTo: "15.06.2023",
    scope: "All",
    issuedVauchers: 17380,
    state: "Paused",
    MSISDNS: "041432424344",
  },
  {
    campaignsName: "Loyalty Campaign",
    validFrom: "01.07.2023",
    validTo: "01.09.2023",
    scope: "Current customers",
    issuedVauchers: 67,
    state: "Canceled",
    MSISDNS: "041938383855",
  },
];
export const CampaignToolMock = [
  {
    campaignName: "Smarpay wallet promo",
    validFrom: "01/05/2023",
    validTo: "01/06/2023",
    campaignScope: "New customers",
    status: "Scheduled",
    state: "Idle",
    MSISDNS: "041111222333",
    voucherType: ["Percentage"],
    products: "2236",
    amount: "10",
    created: "01.05.2023",
    published: "07.05.2023",
    approved: "08.05.2023",
    lastModified: "15.05.2023",
    voucherIssueCap: true,
    voucherIssueLimit: "2000",
    campaignHeroAreaText: "Campaign hero area mock for Smarpay wallet promo",
    campaignHeroImage: "",
    campaignVoucherAreaText: "Voucher area mock for Smarpay wallet promo",
    campaignVoucherImage: "",
  },
  {
    campaignName: "Coca Cola Zero",
    validFrom: "01/06/2023",
    validTo: "12/06/2023",
    campaignScope: ["All"],
    status: "Scheduled",
    state: "Pending",
    MSISDNS: "041432424344",
    voucherType: "Amount",
    products: "2236",
    amount: "20",
    created: "01.05.2023",
    published: "07.05.2023",
    approved: "08.05.2023",
    lastModified: "15.05.2023",
    voucherIssueCap: false,
    voucherIssueLimit: "",
    campaignHeroAreaText: "Campaign hero area mock for All",
    campaignHeroImage: "",
    campaignVoucherAreaText: "Voucher hero area mock for All",
    campaignVoucherImage: "",
  },
  {
    campaignName: "Loyalty Campaign",
    validFrom: "01/07/2023",
    validTo: "01/09/2023",
    campaignScope: ["Current customers"],
    status: "Draft",
    state: "Idle",
    MSISDNS: "041938383855",
    voucherType: "Percentage",
    products: "2236",
    amount: "40",
    created: "01.05.2023",
    published: "07.05.2023",
    voucherIssueCap: false,
    voucherIssueLimit: "",
    approved: "08.05.2023",
    lastModified: "15.05.2023",
    campaignHeroAreaText: "Campaign hero area mock for Current customers",
    campaignHeroImage: "",
    campaignVoucherAreaText: "Voucher hero area mock for Current customers",
    campaignVoucherImage: "",
  },
];
export const CampaignToolDetails = [
  {
    MSISDNS: "041111222333",
    ActivationDate: "01.05.2023",
    ProductID: "22399",
    MachineID: "434222",
    Amount: "0.53",
    CustomerStatus: "New"
  },
  {
    MSISDNS: "041432424344",
    ActivationDate: "01.06.2023",
    ProductID: "22399",
    MachineID: "33212",
    Amount: "0.53",
    CustomerStatus: "Current"
  },
  {
    MSISDNS: "041938383855",
    ActivationDate: "01.07.2023",
    ProductID: "11002",
    MachineID: "55432",
    Amount: "1.2",
    CustomerStatus: "New"
  },
];
